import type { Branding } from '@databink/core/api';
import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import { trpc } from './trpc.js';

/** The client's colors and product name, applied to the page as CSS variables and the title. */

export const brandingQuery = trpc.auth.branding.queryOptions(undefined, { staleTime: Infinity });

const HEX = /^#[0-9a-f]{6}$/i;

export function applyBranding(branding: Branding): void {
  const root = document.documentElement.style;
  if (HEX.test(branding.primary_color)) root.setProperty('--db-primary', branding.primary_color);
  if (branding.accent_color && HEX.test(branding.accent_color))
    root.setProperty('--db-accent', branding.accent_color);
  document.title = branding.product_name;
}

/** Load the deploy's branding once and keep the page wearing it. */
export function useBranding(): Branding | undefined {
  const { data } = useQuery(brandingQuery);
  useEffect(() => {
    if (data) applyBranding(data);
  }, [data]);
  return data;
}
